<template>
  <div class="superdoc-search">
    <img class="superdoc-logo" src="../../assets/images/ic_superdoc_ava.svg" alt="superdoc-logo" />
    <input
      v-model.trim="keyword"
      type="text"
      class="superdoc-input"
      :placeholder="$t('lbl_super_doc.lbl_input_placeholder')"
      @keyup.enter="handleSubmit"
    />
    <button class="superdoc-send" type="button" :disabled="!keyword" @click="handleSubmit">
      Send
    </button>
    <button class="superdoc-open" type="button" aria-label="Open superdoc chat" @click="handleOpenPopup">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SuperDocSearchBar',
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    handleOpenPopup () {
      this.$emit('open-popup')
    },
    handleSubmit () {
      const value = (this.keyword || '').trim()
      if (!value) return

      this.$emit('submit', value)
      this.keyword = ''
    }
  }
}
</script>

<style scoped>
.superdoc-search {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 6px 8px;
}

.superdoc-logo {
  width: 24px;
  height: 24px;
}

.superdoc-input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  font-size: 14px;
  color: #111827;
}

.superdoc-input::placeholder {
  color: #9ca3af;
}

.superdoc-send {
  border: 0;
  border-radius: 8px;
  background: #20429b;
  color: #fff;
  font-size: 13px;
  line-height: 20px;
  padding: 6px 12px;
}

.superdoc-send:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.superdoc-open {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: #eff6ff;
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.superdoc-open:hover {
  background: #dbeafe;
}
</style>
